<div class="p-2">
    <custom-table
        tableName="aiqDialog"
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource()"
        [enableRowSelection]="true"
        [enablePagination]="true"
        (onRowsSelected)="rowSelectionChange($event)">
    </custom-table>
</div>
